import React from 'lib/react';
import {
  EVTextField,
  EVSearchIcon,
} from 'lib/components';
import PropTypes from 'prop-types';
import { ADDRESS_SEARCH_MAX_LENGTH, ADDRESS_SEARCH_PLACEHOLDER } from 'constants/AppConstants';
import OrderStyles from '../OrderStyles';

function InputField(props) {
  const classes = OrderStyles();

  const { InputProps, inputProps, ...rest } = props;

  return (
    <EVTextField
      {...rest}
      variant="outlined"
      placeholder={ADDRESS_SEARCH_PLACEHOLDER}
      inputProps={{ ...inputProps, maxLength: ADDRESS_SEARCH_MAX_LENGTH, style: { textOverflow: 'clip' } }}
      InputProps={{
        ...InputProps,
        startAdornment: <EVSearchIcon className={classes.searchIcon} />,
        className: '',
        classes: {
          root: classes.typeaheadSearchInput,
          focused: classes.typeaheadSearchInputfocused,
        },
      }}
    />
  );
}

InputField.propTypes = {
  InputProps: PropTypes.shape().isRequired,
  inputProps: PropTypes.shape().isRequired,
};

export default InputField;
